module.exports = __webpack_public_path__ + "img/es50_5.e1953d2f.png";